<template>
  <div class="trustpilot">
    <h3 class="trustpilot__title">{{ $t('home.trustpilot.title') }}</h3>
    <div
      ref="trustbox"
      class="trustpilot-widget"
      data-locale="fr-FR"
      data-template-id="53aa8912dec7e10d38f59f36"
      data-businessunit-id="4ec0e70b00006400051186d3"
      data-style-height="140px"
      data-style-width="100%"
      data-theme="light"
      data-stars="5">
      <a
        href="https://fr.trustpilot.com/review/nextories.com"
        target="_blank" rel="noopener">
        Trustpilot
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'trustpilot',
  mounted() {
    if (!window.Trustpilot) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      document.head.appendChild(script);
    } else {
      window.Trustpilot.loadFromElement(this.$refs.trustbox);
    }
  },
};
</script>

<style scoped lang="scss">
.trustpilot {
  padding: 20px 20px 40px;
  background-color: $--color-panel;
  margin: 0;
  @include breakpoint(tablet) {
    border-radius: 4px;
    margin: 0 20px 20px;
  }
  @include breakpoint(wide) {
    margin: 0 $--wide-margin 40px;
  }
  @include breakpoint(wide-xl) {
    margin: 0 $--wide-xl-margin 40px;
  }
  &__title {
    text-transform: uppercase;
    margin-top: 0;
    margin-bottom: 30px
  }
}
</style>
